import * as React from 'react';

function SvgLocationStoreLocatorStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.083 12.557v.018a7.571 7.571 0 01-1.18 4.044l-5.036 7.483a2.25 2.25 0 01-3.734 0l-5.047-7.501a7.57 7.57 0 01-1.169-4.043c.093-4.382 3.716-7.86 8.068-7.775a7.943 7.943 0 018.098 7.774zm-8.098-6.274c-3.554-.07-6.493 2.752-6.568 6.29a6.042 6.042 0 00.925 3.208l5.036 7.484a.75.75 0 001.244 0l5.024-7.466c.61-.963.934-2.079.938-3.218-.08-3.55-3.018-6.368-6.599-6.298zM15 15.297c-1.857 0-3.377-1.447-3.377-3.25 0-1.804 1.52-3.25 3.377-3.25 1.857 0 3.377 1.446 3.377 3.25 0 1.803-1.52 3.25-3.377 3.25zm0-1.5c1.045 0 1.877-.792 1.877-1.75s-.832-1.75-1.877-1.75c-1.044 0-1.877.792-1.877 1.75s.833 1.75 1.877 1.75z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgLocationStoreLocatorStroke;
